<template>
  <div class="character-contain">
    <p class="title">单字「{{ target.title }}」</p>
    <p class="caption">{{ target.caption }}</p>
  </div>
</template>

<script>
export default {
  name: 'CharacterContain',
  props: {
    item: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  computed: {
    target () {
      return this.item.target
    }
  }
}
</script>

<style scoped lang="scss">
.character-contain {
  .title {
    @include sc($font-size-lg, $color-text-heavy);
    padding-bottom: 8px;
  }
  .caption {
    @include sc($font-size-md, $color-text-light);
  }
}
</style>
